import React, { useState, useRef, useEffect, useContext } from "react";
import "./ProductReg.css";
import WindowHeader from "../../Layout/WindowHeader/WindowHeader";
import ActionToolbar from "../../NavBars/ActionToolbar";
import SherComboBox from "../../ComboBoxes/SherComboBox";
import ssLogo from "../../../assets/images/sslogo.png";

import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import { useDbContext } from "../../../context/DbContext";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../app/permissionsSlice";
import { selectActiveLocation } from "../../../app/locationSlice";
import io from "socket.io-client";
import FormDesign, { FormDesignProvider, useFormDesign } from "../../FormDesign/FormDesign";

// Default form fields definition for Product Registration FormDesign
const defaultProductRegFormFields = [
  { fieldId: "SlNo", fieldName: "Sl No", tabIndex: 0, type: "Number", visible: true, enabled: true },
  { fieldId: "ItemCode", fieldName: "Item Code", tabIndex: 1, type: "Text", visible: true, enabled: true },
  { fieldId: "ItemName", fieldName: "Item Name", tabIndex: 2, type: "Select", visible: true, enabled: true },
  { fieldId: "SelectGroup", fieldName: "Select Group", tabIndex: 3, type: "Select", visible: true, enabled: true },
  { fieldId: "ModelNo", fieldName: "Model", tabIndex: 4, type: "Select", visible: true, enabled: true },
  { fieldId: "RateClass", fieldName: "Rate Class", tabIndex: 5, type: "Select", visible: true, enabled: true },
  { fieldId: "HSNCode", fieldName: "HSN Code", tabIndex: 6, type: "Text", visible: true, enabled: true },
  { fieldId: "WstgSales", fieldName: "Wastage (Sales Wt/Gm)", tabIndex: 7, type: "Number", visible: true, enabled: true },
  { fieldId: "WstgPurchase", fieldName: "Wastage (Purchase Wt/Gm)", tabIndex: 8, type: "Number", visible: true, enabled: true },
  { fieldId: "Touch", fieldName: "Touch %", tabIndex: 9, type: "Number", visible: true, enabled: true },
  { fieldId: "MaxStockLimit", fieldName: "Max Stock Limit", tabIndex: 10, type: "Number", visible: true, enabled: true },
  { fieldId: "MCType", fieldName: "M C Type", tabIndex: 11, type: "Select", visible: true, enabled: true },
  { fieldId: "MCValue", fieldName: "M C Value", tabIndex: 12, type: "Number", visible: true, enabled: true },
  { fieldId: "TaxGroup", fieldName: "Tax Group", tabIndex: 13, type: "Select", visible: true, enabled: true },
  { fieldId: "GST", fieldName: "GST %", tabIndex: 14, type: "Number", visible: true, enabled: true },
  { fieldId: "CGST", fieldName: "CGST %", tabIndex: 15, type: "Number", visible: true, enabled: true },
  { fieldId: "SGST", fieldName: "SGST %", tabIndex: 16, type: "Number", visible: true, enabled: true },
  { fieldId: "IGST", fieldName: "IGST %", tabIndex: 17, type: "Number", visible: true, enabled: true },
  { fieldId: "ExciseDuty", fieldName: "Excise Duty %", tabIndex: 18, type: "Number", visible: true, enabled: true },
  { fieldId: "SaveBtn", fieldName: "Save Button", tabIndex: 19, type: "Button", visible: true, enabled: true },
  { fieldId: "EditBtn", fieldName: "Edit Button", tabIndex: 20, type: "Button", visible: true, enabled: true },
];

function ProductReg(props) {
  const { dbCode } = useDbContext();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  return (
    <FormDesignProvider
      formName="PRODUCT REGISTRATION"
      defaultFields={defaultProductRegFormFields}
      dbCode={dbCode}
      apiBaseUrl={apiBaseUrl}
    >
      <ProductRegInner {...props} />
    </FormDesignProvider>
  );
}

// Section Icons matching the image design
const ProductIdentityIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

const WastageIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

const MakingTaxIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <line x1="7" y1="8" x2="17" y2="8" />
    <line x1="7" y1="12" x2="17" y2="12" />
    <line x1="7" y1="16" x2="13" y2="16" />
  </svg>
);

function ProductRegInner({ onClose, val, zIndex }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const permissions = useSelector(selectMenuPermissions);
  const activeLocation = useSelector(selectActiveLocation);

  const { agentCode } = useContext(AuthContext);
  const { dbCode } = useDbContext();

  const agentCodeRef = useRef(agentCode);

  useEffect(() => {
    agentCodeRef.current = agentCode;
  }, [agentCode]);

  useEffect(() => {
    slnoRef.current?.focus?.();
  }, []);

  useEffect(() => {
    const socket = io(apiBaseUrl);
    socket.on("connect", () => {});
    socket.on("StockGroupUpdated", () => {
      fetchStockGroups();
    });
    socket.on("ProductUpdated", () => {
      fetchAllProduct();
      fetchprdEntryno();
    });
    return () => {
      socket.disconnect();
    };
  }, [apiBaseUrl, dbCode]);

  const emitProductUpdate = () => {
    const socket = io(apiBaseUrl);
    socket.emit("ProductUpdated");
    socket.disconnect();
  };

  const [showFormDesignModal, setShowFormDesignModal] = useState(false);

  // ── FormDesign Hook Integration ──
  const {
    fields: formFields,
    loading: formDesignerLoading,
    registerRef,
    handleKeyDown: handleDynamicKeyDown,
    focusField,
    getLabelStyle: getLabelStyleRaw,
    getInputStyle: getInputStyleRaw,
    getContainerStyle,
    isFieldVisible,
    isFieldDisabled,
    isFieldReadOnly,
    getFieldConfig,
    triggerInitialFocus,
  } = useFormDesign();

  const getLabelStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getLabelStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    if (fullStyle.color) filtered.color = fullStyle.color;
    return filtered;
  };

  const getInputStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getInputStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    if (fullStyle.color) filtered.color = fullStyle.color;
    if (fullStyle.backgroundColor) filtered.backgroundColor = fullStyle.backgroundColor;
    if (fullStyle.borderColor) filtered.borderColor = fullStyle.borderColor;
    return filtered;
  };

  const saveButtonRef = useRef(null);
  const editButtonRef = useRef(null);
  const slnoRef = useRef(null);
  const itemNameRef = useRef(null);
  const itemCodeRef = useRef(null);
  const hsnCodeInputRef = useRef(null);
  const selectGroupRef = useRef(null);
  const taxGroupRef = useRef(null);
  const rateClassRef = useRef(null);
  const wSalesInputRef = useRef(null);
  const mcTypeRef = useRef(null);
  const mcInputRef = useRef(null);
  const wPurchaseInputRef = useRef(null);
  const touchInputRef = useRef(null);
  const gstInputRef = useRef(null);
  const cgstInputRef = useRef(null);
  const sgstInputRef = useRef(null);
  const igstInputRef = useRef(null);
  const maxStkLimitInputRef = useRef(null);
  const exsDutyInputRef = useRef(null);
  const modelNoRef = useRef(null);

  const handleKeyDown = (event, currentFieldId) => {
    if (event.key === "Enter" || event.key === "Return") {
      event.preventDefault();
      handleDynamicKeyDown(event, currentFieldId);
    }
  };

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);

  const taxOptions = [
    { label: "tax 0", value: 1 },
    { label: "tax 5", value: 2 },
    { label: "tax 10", value: 3 },
    { label: "tax 12", value: 4 },
  ];

  const getInitialItemCode = () => {
    if (val && val.type === "itemCode") {
      return { value: "", label: val.value };
    }
    return { value: "", label: "" };
  };

  const getInitialItemName = () => {
    if (val && val.type === "itemName") {
      return { value: "", label: val.value };
    } else if (typeof val === 'string' && val) {
      return { value: "", label: val };
    }
    return { value: "", label: "" };
  };

  const [productRegData, setProductRegData] = useState({
    slno: "",
    itemCode: getInitialItemCode(),
    itemName: getInitialItemName(),
    hsnCode: "",
    group: { value: "", label: "" },
    rateClass: { value: "", label: "" },
    wstgSales: "",
    mcType: "On Price",
    mc: "",
    wstgPurchase: "",
    taxGroup: { value: "", label: "" },
    touch: "",
    gst: "",
    cgst: "",
    sgst: "",
    igst: "",
    maxStockLimit: "",
    ExciseDuty: "",
    ornament: 1,
    model: { value: "", label: "" },
    Location: activeLocation ? activeLocation.id : "",
  });

  const handleClear = () => {
    [
      itemCodeRef,
      itemNameRef,
      selectGroupRef,
      rateClassRef,
      taxGroupRef,
      modelNoRef,
    ].forEach((ref) => ref.current?.clearInput?.());

    setProductRegData({
      slno: productRegData.slno,
      itemCode: { value: "", label: "" },
      itemName: { value: "", label: "" },
      hsnCode: "",
      group: { value: "", label: "" },
      rateClass: { value: "", label: "" },
      wstgSales: "",
      mcType: "On Price",
      mc: "",
      wstgPurchase: "",
      taxGroup: { value: "", label: "" },
      touch: "",
      gst: "",
      cgst: "",
      sgst: "",
      igst: "",
      maxStockLimit: "",
      ExciseDuty: "",
      ornament: 1,
      model: { value: "", label: "" },
      Location: activeLocation ? activeLocation.id : "",
    });
    fetchprdEntryno();
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);
    triggerInitialFocus();
    fetchprdEntryno();
    fetchAllProduct();
    fetchRateClass();
    fetchStockGroups();
  };

  const fetchprdEntryno = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/prdregentryNo/${dbCode}`
      );
      const prdentryNo = response.data;
      setProductRegData((prevData) => ({
        ...prevData,
        slno: prdentryNo,
      }));
    } catch (error) {
      console.error("Error fetching entry no:", error.message);
    }
  };

  const [itemNameOpt, setItemNameOpt] = useState([]);
  const [itemCodeOpt, setItemCodeOpt] = useState([]);

  const fetchAllProduct = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectallProduct/${dbCode}`
      );
      const ProductData = response.data;
      const itemName = ProductData.map((item) => ({ value: item.slNo, label: item.itemName }));
      const itemCode = ProductData.map((item) => ({ value: item.slNo, label: item.itemCode }));
      setItemNameOpt(itemName);
      setItemCodeOpt(itemCode);
    } catch (error) {
      console.error("Error fetching Product Reg Values:", error.message);
    }
  };

  const [rateClassOptions, setRateClassOptions] = useState([]);
  const fetchRateClass = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectallrateClass/${dbCode}`
      );
      const RData = response.data;
      // Include touchPercent in options so auto-fill works when rate class is selected
      const rates = RData.map((item) => ({
        value: item.id,
        label: item.rateClass,
        touchPercent: item.touchPercent,
      }));
      setRateClassOptions(rates);
    } catch (error) {
      console.error("Error fetching rateClass Values:", error.message);
    }
  };

  const [groupOptions, setGroupOptions] = useState([]);
  const fetchStockGroups = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/common/getStockGroups/${dbCode}`
      );
      if (response.data && Array.isArray(response.data)) {
        const groups = response.data.map((item) => ({
          value: item.Auto || item.id,
          label: item.GroupName || item.groupName,
          rateClassId: item.RateClass,  // FK to rate class — used for auto-fill
        }));
        setGroupOptions(groups);
      }
    } catch (error) {
      console.error("Error fetching Stock Groups:", error.message);
    }
  };

  const [modelOptions, setModelOptions] = useState([]);
  const fetchModelOptions = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/model/selectall/${dbCode}`
      );
      if (response.data && Array.isArray(response.data)) {
        const models = response.data.map((item) => ({
          value: item.Auto,
          label: item.ModelName,
        }));
        setModelOptions(models);
      }
    } catch (error) {
      console.error("Error fetching Model options:", error.message);
    }
  };

  useEffect(() => {
    fetchprdEntryno();
    fetchAllProduct();
    fetchRateClass();
    fetchStockGroups();
    fetchModelOptions();
  }, [apiBaseUrl, dbCode]);


  const handleSubmit = async () => {
    const confirmSave = window.confirm("Are you sure you want to save this product?");
    if (!confirmSave) return;
    setSaveDisabled(true);    
    try {
      if (
        !productRegData.itemName?.label ||
        !productRegData.group?.label
      ) {
        alert("enter data correctly");
        setSaveDisabled(false);
        return;
      }

      const payload = {
        ...productRegData,
        itemCode: productRegData.itemCode,
        itemName: productRegData.itemName,
      };

      const response = await axios.post(
        `${apiBaseUrl}/main/insertProduct/${dbCode}`,
        payload
      );

      if (response.status === 200) {
        fetchprdEntryno();
        alert("Product registered");
        emitProductUpdate();
        if (val) {
          onClose();
        }
        handleClear();
      } else {
        setSaveDisabled(false);
        console.error("Error submitting data:", response.data);
      }
    } catch (error) {
      setSaveDisabled(false);
      console.error("Error:", error.message);
    }
  };

  const handleUpdate = async () => {
    const confirmEdit = window.confirm("Are you sure you want to edit this product?");
    if (!confirmEdit) return;
    setSaveDisabled(true);
    try {
      if (
        !productRegData.itemName?.label ||
        !productRegData.group?.label
      ) {
        alert("enter data correctly");
        setSaveDisabled(false);
        return;
      }

      const payload = {
        ...productRegData,
        itemCode: productRegData.itemCode,
        itemName: productRegData.itemName,
      };

      const response = await axios.put(
        `${apiBaseUrl}/main/updateProduct/${dbCode}`,
        payload
      );

      if (response.status === 200) {
        fetchprdEntryno();
        alert("Product Edited");
        emitProductUpdate();
        handleClear();
      } else {
        setSaveDisabled(false);
        console.error("Error submitting data:", response.data);
      }
    } catch (error) {
      setSaveDisabled(false);
      console.error("Error:", error.message);
    }
  };

  const handleDelete = async () => {
    try {
      if (!productRegData.slno) {
        alert("Invalid product identifier");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you want to delete this product?....."
      );
      if (!confirmDelete) return;

      const response = await axios.delete(
        `${apiBaseUrl}/main/deleteProduct/${dbCode}/${productRegData.slno}?locationId=${activeLocation ? activeLocation.id : ''}`
      );

      if (response.status === 200 && response.data.success) {
        alert("Product deleted ");
        fetchprdEntryno();
        handleClear();
      } else {
        console.error("Failed to delete product:", response.data.message);
        alert("Failed to delete the product. Please try again.");
      }
    } catch (error) {
      console.error("Error during deletion:", error.message);
      alert("An error occurred while deleting the product. Please try again.");
    }
  };

  const populateProductData = (foundData) => {
    if (!foundData) return;

    // Restore group as ID so ComboBox can match the option
    const matchedGroup = groupOptions.find(
      (g) => String(g.value) === String(foundData.groupId) || g.label === foundData.groupName
    );
    // Restore rateClass as ID so ComboBox can match the option
    const matchedRateClass = rateClassOptions.find(
      (r) => String(r.value) === String(foundData.rateClassId) || r.label === foundData.rateClass
    );
    // Restore model as ID so ComboBox can match the option
    const matchedModel = modelOptions.find(
      (m) => String(m.value) === String(foundData.ModelNo) || m.label === foundData.modelName
    );

    setProductRegData({
      ...productRegData,
      slno: foundData.slNo,
      itemCode: { value: String(foundData.slNo || ""), label: foundData.itemCode || "" },
      itemName: { value: String(foundData.slNo || ""), label: foundData.itemName || "" },
      hsnCode: foundData.hsnCode || "",
      group: {
        value: matchedGroup ? String(matchedGroup.value) : (foundData.groupId ? String(foundData.groupId) : ""),
        label: matchedGroup ? matchedGroup.label : (foundData.groupName || "")
      },
      rateClass: {
        value: matchedRateClass ? String(matchedRateClass.value) : (foundData.rateClassId ? String(foundData.rateClassId) : ""),
        label: matchedRateClass ? matchedRateClass.label : (foundData.rateClass || "")
      },
      wstgSales: foundData.wastageSales || "",
      mcType: foundData.mcType || "On Price",
      mc: foundData.mc || "",
      wstgPurchase: foundData.wastagePurchase || "",
      taxGroup: {
        value: foundData.taxGroup_id ? String(foundData.taxGroup_id) : "",
        label: foundData.taxGroup || ""
      },
      touch: foundData.touchPercent || "",
      gst: foundData.gst || "",
      cgst: foundData.cgst || "",
      sgst: foundData.sgst || "",
      igst: foundData.igst || "",
      maxStockLimit: foundData.maxStockLimit || "",
      ExciseDuty: foundData.Duty || "",
      ornament: 1,
      model: {
        value: matchedModel ? String(matchedModel.value) : (foundData.ModelNo ? String(foundData.ModelNo) : ""),
        label: matchedModel ? matchedModel.label : (foundData.modelName || "")
      },
    });
    setEditDisabled(false);
    setDeleteDisabled(false);
    setSaveDisabled(true);
  };

  const handleFindFirst = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/main/selectFirstProduct/${dbCode}`);
      if (response.status === 200 && response.data) {
        populateProductData(response.data);
      }
    } catch (error) {
      console.error("Error fetching first product:", error.message);
    }
  };

  const handlePrevious = async () => {
    if (!productRegData.slno) return handleFindFirst();
    try {
      const response = await axios.get(`${apiBaseUrl}/main/selectPreviousProduct/${productRegData.slno}/${dbCode}`);
      if (response.status === 200 && response.data) {
        populateProductData(response.data);
      }
    } catch (error) {
      console.error("Error fetching previous product:", error.message);
    }
  };

  const handleNext = async () => {
    if (!productRegData.slno) return handleLast();
    try {
      const response = await axios.get(`${apiBaseUrl}/main/selectNextProduct/${productRegData.slno}/${dbCode}`);
      if (response.status === 200 && response.data) {
        populateProductData(response.data);
      }
    } catch (error) {
      console.error("Error fetching next product:", error.message);
    }
  };

  const handleLast = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/main/selectLastProduct/${dbCode}`);
      if (response.status === 200 && response.data) {
        populateProductData(response.data);
      }
    } catch (error) {
      console.error("Error fetching last product:", error.message);
    }
  };

  const handleFindbyitemName = async () => {
    const nameVal = productRegData.itemName?.label;
    if (!nameVal) {
      alert("Select ItemName");
      return;
    }

    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectProductByname/${encodeURIComponent(nameVal)}/${dbCode}`
      );

      if (response.status === 200 && response.data) {
        populateProductData(response.data);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleFindbyitemCode = async () => {
    const codeVal = productRegData.itemCode?.label;
    if (!codeVal) {
      alert("Select ItemCode");
      return;
    }

    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectProductByCode/${encodeURIComponent(codeVal)}/${dbCode}`
      );

      if (response.status === 200 && response.data) {
        populateProductData(response.data);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleGSTChange = (e) => {
    const gstValue = e.target.value;

    if (!isNaN(gstValue) && gstValue !== "") {
      const halfGstValue = (parseFloat(gstValue) / 2).toFixed(2);

      setProductRegData({
        ...productRegData,
        gst: gstValue,
        cgst: halfGstValue,
        sgst: halfGstValue,
        igst: gstValue,
      });
    } else {
      setProductRegData({
        ...productRegData,
        gst: gstValue,
        cgst: "",
        sgst: "",
        igst: "",
      });
    }
  };

  const hasSavePermission = permissions["productReg"]?.actions?.Save ?? true;
  const hasEditPermission = permissions["productReg"]?.actions?.Edit ?? true;
  const hasDeletePermission = permissions["productReg"]?.actions?.Delete ?? true;

  const getItemValue = (val) => {
    if (Array.isArray(val)) return val[1] || val[0] || "";
    if (typeof val === "object" && val !== null) return val.label || val.value || "";
    return val || "";
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-slate-900/60 backdrop-blur-xs p-3 font-Inter select-none"
      style={{ zIndex: zIndex || 100, fontFamily: "Inter, sans-serif" }}
    >
      <div className="bg-white font-normal font-Inter w-[840px] max-w-[95vw] h-auto rounded-xl shadow-2xl flex flex-col overflow-hidden border border-slate-200" style={{ fontFamily: "Inter, sans-serif" }}>
        
        {/* Header */}
        <WindowHeader
          title="Product Registration"
          logo={ssLogo}
          onClose={onClose}
          className="!h-9 text-xs text-white rounded-t-[8px]"
          titleClassName="text-xs font-semibold text-white"
          logoClassName="!h-4.5"
          closeBtnClassName="!w-6 !h-6 border-none rounded-[4px] mr-1.5 font-Inter"
        />

        {/* Action Toolbar */}
        <div className="w-full flex-shrink-0 font-Inter" style={{ fontFamily: "Inter, sans-serif" }}>
          <ActionToolbar
            width="100%"
            height="auto"
            bgColor="#EAF0FC"
            size="small"
            iconSize={14}
            navBgColor="#0f56d3"
            navIconColor="#ffffff"
            buttonGap="4px"
            arrowGap="4px"
            showSave={isFieldVisible("SaveBtn") && hasSavePermission}
            showPrint={true}
            showClear={true}
            showFind={hasSavePermission}
            showEdit={isFieldVisible("EditBtn") && hasEditPermission}
            showDelete={hasDeletePermission}
            showExit={true}
            showNavigation={true}
            saveDisabled={isFieldDisabled("SaveBtn") || saveDisabled || !editDisabled}
            editDisabled={isFieldDisabled("EditBtn") || editDisabled || !hasEditPermission}
            deleteDisabled={hasDeletePermission ? deleteDisabled : true}
            findDisabled={false}
            dataFound={!editDisabled}
            onSave={handleSubmit}
            onClear={handleClear}
            onFind={handleFindbyitemName}
            onEdit={handleUpdate}
            onDelete={handleDelete}
            onExit={onClose}
            onFirst={handleFindFirst}
            onPrevious={handlePrevious}
            onNext={handleNext}
            onLast={handleLast}
            saveRef={saveButtonRef}
            editRef={editButtonRef}
            showSettingsBar={true}
            settingsOptions={[
              {
                label: "Form Design",
                onClick: () => setShowFormDesignModal(true),
              },
            ]}
          />
        </div>

        {/* Form Content Body: 2-Column Split Layout */}
        <div className="w-full p-2.5 bg-[#f0f4f9] grid grid-cols-12 gap-2.5 max-h-[82vh] overflow-y-auto font-Inter" style={{ fontFamily: "Inter, sans-serif" }}>
          
          {/* LEFT COLUMN: PRODUCT IDENTITY (5 Cols) */}
          <div className="col-span-5 bg-[#e8f0fe] rounded-md border border-[#c2d7f8] overflow-hidden shadow-xs font-Inter flex flex-col">
            <div className="bg-[#d3e3fd] px-2.5 py-1 flex items-center gap-1.5 border-b border-[#c2d7f8]">
              <ProductIdentityIcon />
              <span className="text-[10.5px] font-bold text-[#1a3abf] uppercase tracking-wider font-Inter">
                PRODUCT IDENTITY
              </span>
            </div>

            <div className="p-2.5 flex flex-col gap-1.5 bg-white flex-1 font-Inter">
              {/* Sl No (Single row, same width as Rate Class) */}
              <div className="flex flex-col gap-0.5 w-[calc(50%-4px)]" style={getContainerStyle("SlNo")}>
                <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("SlNo")}>
                  Sl No
                </label>
                <input
                  ref={(el) => {
                    registerRef("SlNo")(el);
                    slnoRef.current = el;
                  }}
                  disabled={isFieldDisabled("SlNo")}
                  readOnly={isFieldReadOnly("SlNo") || true}
                  style={getInputStyle("SlNo")}
                  className="w-full h-7 px-2 bg-slate-50 border border-slate-300 rounded text-[11px] text-slate-800 focus:outline-none focus:border-blue-600 focus:bg-white transition-all font-Inter box-border"
                  value={productRegData.slno || ""}
                  onChange={(e) =>
                    setProductRegData({ ...productRegData, slno: e.target.value })
                  }
                  onKeyDown={(e) => handleKeyDown(e, "SlNo")}
                />
              </div>

              {/* Item Code (Single row, full width) */}
              <div className="flex flex-col gap-0.5" style={getContainerStyle("ItemCode")}>
                <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("ItemCode")}>
                  Item Code
                </label>
                <div className="flex items-center gap-1">
                  <div className="flex-1">
                    <SherComboBox
                      comboRef={(el) => {
                        registerRef("ItemCode")(el);
                        itemCodeRef.current = el;
                      }}
                      disabled={isFieldDisabled("ItemCode")}
                      readOnly={isFieldReadOnly("ItemCode")}
                      options={itemCodeOpt}
                      value={productRegData.itemCode?.value || productRegData.itemCode?.label}
                      onSelect={(opt) =>
                        setProductRegData({ ...productRegData, itemCode: { value: String(opt.value), label: opt.label } })
                      }
                      onInputChange={(text) =>
                        setProductRegData({ ...productRegData, itemCode: { value: "", label: text } })
                      }
                      onFreeInput={(text) =>
                        setProductRegData({ ...productRegData, itemCode: { value: "", label: text } })
                      }
                      onKeyDown={(e) => handleKeyDown(e, "ItemCode")}
                      placeholder="Code"
                      inputWidth="100%"
                      inputHeight="28px"
                      inputClassName="border border-slate-300 rounded focus:border-blue-600 shadow-2xs font-Inter"
                      inputStyle={{ fontSize: "11px", paddingLeft: "6px", fontFamily: "Inter, sans-serif", ...getInputStyle("ItemCode") }}
                    />
                  </div>
                  <button
                    type="button"
                    onClick={handleFindbyitemCode}
                    className="h-7 px-2 bg-[#1a3abf] hover:bg-[#142e99] active:bg-[#0f2378] text-white text-[10px] font-semibold rounded shadow-2xs transition-all flex items-center justify-center shrink-0 font-Inter box-border"
                    title="Search Code"
                  >
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <circle cx="11" cy="11" r="8" />
                      <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Item Name */}
              <div className="flex flex-col gap-0.5" style={getContainerStyle("ItemName")}>
                <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("ItemName")}>
                  Item Name <span className="text-red-500">*</span>
                </label>
                <SherComboBox
                  comboRef={(el) => {
                    registerRef("ItemName")(el);
                    itemNameRef.current = el;
                  }}
                  disabled={isFieldDisabled("ItemName")}
                  readOnly={isFieldReadOnly("ItemName")}
                  options={itemNameOpt}
                  value={productRegData.itemName?.value || productRegData.itemName?.label}
                  onSelect={(opt) =>
                    setProductRegData({ ...productRegData, itemName: { value: String(opt.value), label: opt.label } })
                  }
                  onInputChange={(text) =>
                    setProductRegData({ ...productRegData, itemName: { value: "", label: text } })
                  }
                  onFreeInput={(text) =>
                    setProductRegData({ ...productRegData, itemName: { value: "", label: text } })
                  }
                  onKeyDown={(e) => handleKeyDown(e, "ItemName")}
                  placeholder="Enter product name"
                  inputWidth="100%"
                  inputHeight="28px"
                  inputClassName="border border-slate-300 rounded focus:border-blue-600 shadow-2xs font-Inter"
                  inputStyle={{ fontSize: "11px", paddingLeft: "6px", fontFamily: "Inter, sans-serif", ...getInputStyle("ItemName") }}
                />
              </div>

              {/* Select Group */}
              <div className="flex flex-col gap-0.5" style={getContainerStyle("SelectGroup")}>
                <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("SelectGroup")}>
                  Select Group <span className="text-red-500">*</span>
                </label>
                <SherComboBox
                  comboRef={(el) => {
                    registerRef("SelectGroup")(el);
                    selectGroupRef.current = el;
                  }}
                  disabled={isFieldDisabled("SelectGroup")}
                  readOnly={isFieldReadOnly("SelectGroup")}
                  options={groupOptions}
                  value={productRegData.group?.value || productRegData.group?.label}
                  onSelect={(opt) => {
                    // Auto-fill Rate Class and Touch % from the group's linked rate class
                    const matchedRateClass = rateClassOptions.find(
                      (rc) => String(rc.value) === String(opt.rateClassId)
                    );
                    setProductRegData({
                      ...productRegData,
                      group: { value: String(opt.value), label: opt.label },
                      rateClass: matchedRateClass ? { value: String(matchedRateClass.value), label: matchedRateClass.label } : productRegData.rateClass,
                      touch: matchedRateClass ? (matchedRateClass.touchPercent ?? productRegData.touch) : productRegData.touch,
                    });
                  }}
                  onInputChange={(text) =>
                    setProductRegData({ ...productRegData, group: { value: "", label: text } })
                  }
                  onFreeInput={(text) =>
                    setProductRegData({ ...productRegData, group: { value: "", label: text } })
                  }
                  onKeyDown={(e) => handleKeyDown(e, "SelectGroup")}
                  placeholder="Choose group.."
                  inputWidth="100%"
                  inputHeight="28px"
                  inputClassName="border border-slate-300 rounded focus:border-blue-600 shadow-2xs font-Inter"
                  inputStyle={{ fontSize: "11px", paddingLeft: "6px", fontFamily: "Inter, sans-serif", ...getInputStyle("SelectGroup") }}
                />
              </div>


              {/* Rate Class & HSN Code in 2 cols */}
              <div className="grid grid-cols-2 gap-2">
                {/* Rate Class */}
                <div className="flex flex-col gap-0.5" style={getContainerStyle("RateClass")}>
                  <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("RateClass")}>
                    Rate Class
                  </label>
                  <SherComboBox
                    comboRef={(el) => {
                      registerRef("RateClass")(el);
                      rateClassRef.current = el;
                    }}
                    disabled={isFieldDisabled("RateClass")}
                    readOnly={isFieldReadOnly("RateClass")}
                    options={rateClassOptions}
                    value={productRegData.rateClass?.value || productRegData.rateClass?.label}
                    onSelect={(opt) => {
                      // Auto-fill Touch % when rate class is selected
                      setProductRegData({
                        ...productRegData,
                        rateClass: { value: String(opt.value), label: opt.label },
                        touch: opt.touchPercent ?? productRegData.touch,
                      });
                    }}
                    onInputChange={(text) =>
                      setProductRegData({ ...productRegData, rateClass: { value: "", label: text } })
                    }
                    onFreeInput={(text) =>
                      setProductRegData({ ...productRegData, rateClass: { value: "", label: text } })
                    }
                    onKeyDown={(e) => handleKeyDown(e, "RateClass")}
                    placeholder="Choose class.."
                    inputWidth="100%"
                    inputHeight="28px"
                    inputClassName="border border-slate-300 rounded focus:border-blue-600 shadow-2xs font-Inter"
                    inputStyle={{ fontSize: "11px", paddingLeft: "6px", fontFamily: "Inter, sans-serif", ...getInputStyle("RateClass") }}
                  />
                </div>

                {/* HSN Code */}
                <div className="flex flex-col gap-0.5" style={getContainerStyle("HSNCode")}>
                  <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("HSNCode")}>
                    HSN Code
                  </label>
                  <input
                    ref={(el) => {
                      registerRef("HSNCode")(el);
                      hsnCodeInputRef.current = el;
                    }}
                    disabled={isFieldDisabled("HSNCode")}
                    readOnly={isFieldReadOnly("HSNCode")}
                    style={getInputStyle("HSNCode")}
                    className="w-full h-7 px-2 border border-slate-300 rounded text-[11px] text-slate-800 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 transition-all placeholder:text-slate-400 font-Inter box-border"
                    placeholder="71131100"
                    value={productRegData.hsnCode || ""}
                    onChange={(e) =>
                      setProductRegData({ ...productRegData, hsnCode: e.target.value })
                    }
                    onKeyDown={(e) => handleKeyDown(e, "HSNCode")}
                  />
                </div>
              </div>

            </div>
          </div>

          {/* RIGHT COLUMN: WASTAGE, MAKING CHARGE & TAX (7 Cols) */}
          <div className="col-span-7 flex flex-col gap-2">
            
            {/* WASTAGE & TOUCH CARD */}
            <div className="bg-[#e8f0fe] rounded-md border border-[#c2d7f8] overflow-hidden shadow-xs font-Inter">
              <div className="bg-[#d3e3fd] px-2.5 py-1 flex items-center gap-1.5 border-b border-[#c2d7f8]">
                <WastageIcon />
                <span className="text-[10.5px] font-bold text-[#1a3abf] uppercase tracking-wider font-Inter">
                  WASTAGE & TOUCH
                </span>
              </div>

              <div className="p-2.5 grid grid-cols-2 gap-2 bg-white font-Inter">
                {/* Wastage Sales */}
                <div className="flex flex-col gap-0.5" style={getContainerStyle("WstgSales")}>
                  <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("WstgSales")}>
                    Wastage (Sales Wt/Gm)
                  </label>
                  <input
                    ref={(el) => {
                      registerRef("WstgSales")(el);
                      wSalesInputRef.current = el;
                    }}
                    disabled={isFieldDisabled("WstgSales")}
                    readOnly={isFieldReadOnly("WstgSales")}
                    style={getInputStyle("WstgSales")}
                    type="text"
                    className="w-full h-7 px-2 text-right border border-slate-300 rounded text-[11px] text-slate-800 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 transition-all placeholder:text-slate-400 font-Inter box-border"
                    placeholder="0.00"
                    value={productRegData.wstgSales || ""}
                    onChange={(e) =>
                      setProductRegData({ ...productRegData, wstgSales: e.target.value })
                    }
                    onKeyDown={(e) => handleKeyDown(e, "WstgSales")}
                  />
                </div>

                {/* Wastage Purchase */}
                <div className="flex flex-col gap-0.5" style={getContainerStyle("WstgPurchase")}>
                  <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("WstgPurchase")}>
                    Wastage (Purchase Wt/Gm)
                  </label>
                  <input
                    ref={(el) => {
                      registerRef("WstgPurchase")(el);
                      wPurchaseInputRef.current = el;
                    }}
                    disabled={isFieldDisabled("WstgPurchase")}
                    readOnly={isFieldReadOnly("WstgPurchase")}
                    style={getInputStyle("WstgPurchase")}
                    type="text"
                    className="w-full h-7 px-2 text-right border border-slate-300 rounded text-[11px] text-slate-800 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 transition-all placeholder:text-slate-400 font-Inter box-border"
                    placeholder="0.00"
                    value={productRegData.wstgPurchase || ""}
                    onChange={(e) =>
                      setProductRegData({ ...productRegData, wstgPurchase: e.target.value })
                    }
                    onKeyDown={(e) => handleKeyDown(e, "WstgPurchase")}
                  />
                </div>

                {/* Touch % */}
                <div className="flex flex-col gap-0.5" style={getContainerStyle("Touch")}>
                  <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("Touch")}>
                    Touch % (Default Purity)
                  </label>
                  <input
                    ref={(el) => {
                      registerRef("Touch")(el);
                      touchInputRef.current = el;
                    }}
                    disabled={isFieldDisabled("Touch")}
                    readOnly={isFieldReadOnly("Touch")}
                    style={getInputStyle("Touch")}
                    type="text"
                    className="w-full h-7 px-2 text-right border border-slate-300 rounded text-[11px] text-slate-800 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 transition-all placeholder:text-slate-400 font-Inter box-border"
                    placeholder="0.00"
                    value={productRegData.touch || ""}
                    onChange={(e) =>
                      setProductRegData({ ...productRegData, touch: e.target.value })
                    }
                    onKeyDown={(e) => handleKeyDown(e, "Touch")}
                  />
                </div>

                {/* Max Stock Limit */}
                <div className="flex flex-col gap-0.5" style={getContainerStyle("MaxStockLimit")}>
                  <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("MaxStockLimit")}>
                    Max Stock Limit (Gross Wt)
                  </label>
                  <input
                    ref={(el) => {
                      registerRef("MaxStockLimit")(el);
                      maxStkLimitInputRef.current = el;
                    }}
                    disabled={isFieldDisabled("MaxStockLimit")}
                    readOnly={isFieldReadOnly("MaxStockLimit")}
                    style={getInputStyle("MaxStockLimit")}
                    type="text"
                    className="w-full h-7 px-2 text-right border border-slate-300 rounded text-[11px] text-slate-800 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 transition-all placeholder:text-slate-400 font-Inter box-border"
                    placeholder="0.00"
                    value={productRegData.maxStockLimit || ""}
                    onChange={(e) =>
                      setProductRegData({ ...productRegData, maxStockLimit: e.target.value })
                    }
                    onKeyDown={(e) => handleKeyDown(e, "MaxStockLimit")}
                  />
                </div>
              </div>
            </div>

            {/* MAKING CHARGE & TAX CARD */}
            <div className="bg-[#e8f0fe] rounded-md border border-[#c2d7f8] overflow-hidden shadow-xs flex flex-col font-Inter">
              <div className="bg-[#d3e3fd] px-2.5 py-1 flex items-center gap-1.5 border-b border-[#c2d7f8]">
                <MakingTaxIcon />
                <span className="text-[10.5px] font-bold text-[#1a3abf] uppercase tracking-wider font-Inter">
                  MAKING CHARGE & TAX
                </span>
              </div>

              <div className="p-2.5 bg-white flex flex-col gap-1.5 font-Inter">
                {/* Top row: MC Type, MC Value, Tax Group */}
                <div className="grid grid-cols-3 gap-2">
                  {/* M C Type */}
                  <div className="flex flex-col gap-0.5" style={getContainerStyle("MCType")}>
                    <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("MCType")}>
                      M C Type
                    </label>
                    <select
                      ref={(el) => {
                        registerRef("MCType")(el);
                        mcTypeRef.current = el;
                      }}
                      disabled={isFieldDisabled("MCType")}
                      style={getInputStyle("MCType")}
                      className="w-full h-7 px-2 bg-white border border-slate-300 rounded text-[11px] text-slate-800 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 transition-all cursor-pointer font-Inter box-border"
                      value={productRegData.mcType || "On Price"}
                      onChange={(e) =>
                        setProductRegData({ ...productRegData, mcType: e.target.value })
                      }
                      onKeyDown={(e) => handleKeyDown(e, "MCType")}
                    >
                      <option value="On Price">On Price</option>
                      <option value="Per Gm">Per Gm</option>
                    </select>
                  </div>

                  {/* M C Value */}
                  <div className="flex flex-col gap-0.5" style={getContainerStyle("MCValue")}>
                    <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("MCValue")}>
                      M C Value
                    </label>
                    <input
                      ref={(el) => {
                        registerRef("MCValue")(el);
                        mcInputRef.current = el;
                      }}
                      disabled={isFieldDisabled("MCValue")}
                      readOnly={isFieldReadOnly("MCValue")}
                      style={getInputStyle("MCValue")}
                      type="text"
                      className="w-full h-7 px-2 text-right border border-slate-300 rounded text-[11px] text-slate-800 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 transition-all placeholder:text-slate-400 font-Inter box-border"
                      placeholder="0.00"
                      value={productRegData.mc || ""}
                      onChange={(e) =>
                        setProductRegData({ ...productRegData, mc: e.target.value })
                      }
                      onKeyDown={(e) => handleKeyDown(e, "MCValue")}
                    />
                  </div>

                  {/* Tax Group */}
                  <div className="flex flex-col gap-0.5" style={getContainerStyle("TaxGroup")}>
                    <label className="text-[10.5px] font-semibold text-slate-700 font-Inter" style={getLabelStyle("TaxGroup")}>
                      Tax Group
                    </label>
                    <SherComboBox
                      comboRef={(el) => {
                        registerRef("TaxGroup")(el);
                        taxGroupRef.current = el;
                      }}
                      disabled={isFieldDisabled("TaxGroup")}
                      readOnly={isFieldReadOnly("TaxGroup")}
                      options={taxOptions}
                      value={productRegData.taxGroup?.value || productRegData.taxGroup?.label}
                      onSelect={(opt) =>
                        setProductRegData({ ...productRegData, taxGroup: { value: String(opt.value), label: opt.label } })
                      }
                      onInputChange={(text) =>
                        setProductRegData({ ...productRegData, taxGroup: { value: "", label: text } })
                      }
                      onFreeInput={(text) =>
                        setProductRegData({ ...productRegData, taxGroup: { value: "", label: text } })
                      }
                      onKeyDown={(e) => handleKeyDown(e, "TaxGroup")}
                      placeholder="Tax group.."
                      inputWidth="100%"
                      inputHeight="28px"
                      inputClassName="border border-slate-300 rounded focus:border-blue-600 shadow-2xs font-Inter"
                      inputStyle={{ fontSize: "11px", paddingLeft: "6px", fontFamily: "Inter, sans-serif", ...getInputStyle("TaxGroup") }}
                    />
                  </div>
                </div>

                {/* Bottom row: GST Breakdown */}
                <div className="flex flex-col gap-0.5 pt-1 border-t border-slate-100 font-Inter">
                  <span className="text-[9.5px] font-bold text-slate-600 uppercase tracking-wider font-Inter">
                    GST BREAKDOWN
                  </span>

                  <div className="grid grid-cols-5 gap-1.5 font-Inter">
                    {/* GST % */}
                    <div className="flex flex-col gap-0.5" style={getContainerStyle("GST")}>
                      <span className="text-[9.5px] font-medium text-slate-500 font-Inter" style={getLabelStyle("GST")}>GST %</span>
                      <input
                        ref={(el) => {
                          registerRef("GST")(el);
                          gstInputRef.current = el;
                        }}
                        disabled={isFieldDisabled("GST")}
                        readOnly={isFieldReadOnly("GST")}
                        style={getInputStyle("GST")}
                        type="text"
                        className="w-full h-7 px-1.5 text-right border border-slate-300 rounded text-[11px] focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 font-Inter box-border"
                        value={productRegData.gst || ""}
                        onChange={(e) => {
                          setProductRegData({ ...productRegData, gst: e.target.value });
                          handleGSTChange(e);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, "GST")}
                      />
                    </div>

                    {/* CGST % */}
                    <div className="flex flex-col gap-0.5" style={getContainerStyle("CGST")}>
                      <span className="text-[9.5px] font-medium text-slate-500 font-Inter" style={getLabelStyle("CGST")}>CGST %</span>
                      <input
                        ref={(el) => {
                          registerRef("CGST")(el);
                          cgstInputRef.current = el;
                        }}
                        disabled={isFieldDisabled("CGST")}
                        readOnly={isFieldReadOnly("CGST")}
                        style={getInputStyle("CGST")}
                        type="text"
                        className="w-full h-7 px-1.5 text-right border border-slate-300 rounded text-[11px] focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 font-Inter box-border"
                        value={productRegData.cgst || ""}
                        onChange={(e) =>
                          setProductRegData({ ...productRegData, cgst: e.target.value })
                        }
                        onKeyDown={(e) => handleKeyDown(e, "CGST")}
                      />
                    </div>

                    {/* SGST % */}
                    <div className="flex flex-col gap-0.5" style={getContainerStyle("SGST")}>
                      <span className="text-[9.5px] font-medium text-slate-500 font-Inter" style={getLabelStyle("SGST")}>SGST %</span>
                      <input
                        ref={(el) => {
                          registerRef("SGST")(el);
                          sgstInputRef.current = el;
                        }}
                        disabled={isFieldDisabled("SGST")}
                        readOnly={isFieldReadOnly("SGST")}
                        style={getInputStyle("SGST")}
                        type="text"
                        className="w-full h-7 px-1.5 text-right border border-slate-300 rounded text-[11px] focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 font-Inter box-border"
                        value={productRegData.sgst || ""}
                        onChange={(e) =>
                          setProductRegData({ ...productRegData, sgst: e.target.value })
                        }
                        onKeyDown={(e) => handleKeyDown(e, "SGST")}
                      />
                    </div>

                    {/* IGST % */}
                    <div className="flex flex-col gap-0.5" style={getContainerStyle("IGST")}>
                      <span className="text-[9.5px] font-medium text-slate-500 font-Inter" style={getLabelStyle("IGST")}>IGST %</span>
                      <input
                        ref={(el) => {
                          registerRef("IGST")(el);
                          igstInputRef.current = el;
                        }}
                        disabled={isFieldDisabled("IGST")}
                        readOnly={isFieldReadOnly("IGST")}
                        style={getInputStyle("IGST")}
                        type="text"
                        className="w-full h-7 px-1.5 text-right border border-slate-300 rounded text-[11px] focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 font-Inter box-border"
                        value={productRegData.igst || ""}
                        onChange={(e) =>
                          setProductRegData({ ...productRegData, igst: e.target.value })
                        }
                        onKeyDown={(e) => handleKeyDown(e, "IGST")}
                      />
                    </div>

                    {/* Excise Duty % */}
                    <div className="flex flex-col gap-0.5" style={getContainerStyle("ExciseDuty")}>
                      <span className="text-[9.5px] font-medium text-slate-500 font-Inter whitespace-nowrap" title="Excise Duty %" style={getLabelStyle("ExciseDuty")}>Excise Duty %</span>
                      <input
                        ref={(el) => {
                          registerRef("ExciseDuty")(el);
                          exsDutyInputRef.current = el;
                        }}
                        disabled={isFieldDisabled("ExciseDuty")}
                        readOnly={isFieldReadOnly("ExciseDuty")}
                        style={getInputStyle("ExciseDuty")}
                        type="text"
                        className="w-full h-7 px-1.5 text-right border border-slate-300 rounded text-[11px] focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 font-Inter box-border"
                        value={productRegData.ExciseDuty || ""}
                        onChange={(e) =>
                          setProductRegData({ ...productRegData, ExciseDuty: e.target.value })
                        }
                        onKeyDown={(e) => handleKeyDown(e, "ExciseDuty")}
                      />
                    </div>
                  </div>
                </div>

                {/* Bottom Right Action Buttons */}
                <div className="flex items-center justify-end gap-2 pt-2 border-t border-slate-100 font-Inter">
                  <button
                    type="button"
                    onClick={handleClear}
                    className="px-4 py-1 border border-slate-300 bg-white hover:bg-slate-50 active:bg-slate-100 text-slate-700 text-[11px] font-semibold rounded shadow-2xs transition-all cursor-pointer font-Inter"
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    ref={(el) => {
                      registerRef("SaveBtn")(el);
                      saveButtonRef.current = el;
                    }}
                    onClick={!editDisabled ? handleUpdate : handleSubmit}
                    className="px-5 py-1 bg-[#1a3abf] hover:bg-[#142e99] active:bg-[#0f2378] text-white text-[11px] font-bold rounded shadow-sm transition-all cursor-pointer font-Inter"
                  >
                    {!editDisabled ? "Update Product" : "Save Product"}
                  </button>
                </div>

              </div>
            </div>

          </div>

        </div>

        {/* Form Design Settings Modal */}
        {showFormDesignModal && (
          <FormDesign
            onClose={() => setShowFormDesignModal(false)}
            formName="PRODUCT REGISTRATION"
            initialFields={defaultProductRegFormFields}
            zIndex={(zIndex || 100) + 50}
          />
        )}
      </div>
    </div>
  );
}

export default ProductReg;
